export default __webpack_public_path__ + "static/media/pp-2.f040832a.jpg";